import * as React from 'react';

import { cssClass, fillStyle, flexColumnStyle } from '../../style';
import { FlowSubplaceProps } from '../types/FlowSubplaceProps';
import { FlowRunHistoryDataGridView } from './FlowRunHistoryDataGridView';

const cssPrefix = 'FlowRunHistorySubplace';
const rootClass = cssClass(cssPrefix, 'root', fillStyle, flexColumnStyle);

export class FlowRunHistorySubplace extends React.Component<FlowSubplaceProps> {

  public constructor(props: FlowSubplaceProps) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <div className={rootClass}>
        <FlowRunHistoryDataGridView
          angularContext={this.props.angularContext}
          subplace={this.props.place.subplace('runHistory')}
          translate={this.props.translate}
          scheduleFrequencyDescriptionFilter={this.props.scheduleFrequencyDescriptionFilter}
          siteUrls={this.props.siteUrls}
          flowAllowedActions={this.props.flowAllowedActions}
        />
      </div>
    );
  }
}
